module.exports = __webpack_public_path__ + "static/media/arrow-forward.c348d2d4.svg";